import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-promo-tag',
  templateUrl: './promo-tag.component.html',
  styleUrls: ['./promo-tag.component.scss']
})
export class PromoTagComponent implements OnInit {
  @Input() shape ?  = 'rounded';
  @Input() value ?  = '30%';
  @Input() color?: string;


  constructor() { }

  ngOnInit(): void {
  }

}
